import { render } from "./Members2.vue?vue&type=template&id=83c951b8&scoped=true"
import script from "./Members2.vue?vue&type=script&lang=js"
export * from "./Members2.vue?vue&type=script&lang=js"

import "./Members2.vue?vue&type=style&index=0&id=83c951b8&scoped=true&lang=css"

import exportComponent from "E:\\Vue_Project\\JamoatFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83c951b8"]])

export default __exports__